import { GetServerSideProps, NextPage } from "next";
import QueryString from "qs";
import dynamic from "next/dynamic";
const UseCasePage = dynamic(() => import("@/Components/pages/UseCasePage"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL as string;

interface UseCaseDetailProps {
  apiResData: any; // You can replace `any` with a stricter type from your Strapi schema
  slug: string;
  isNew: boolean;
}

export const getServerSideProps: GetServerSideProps<
  UseCaseDetailProps
> = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const slug = ctx.params?.slug as string;

  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep",
    },
    {
      encodeValuesOnly: false,
    },
  );

  const apiRes = await fetch(
    `${baseUrl}use-cases?${decodeURIComponent(query)}`,
  );
  const apiResData = await apiRes.json();
  if (apiResData?.data?.length === 0) return { notFound: true };
  const isNew = apiResData?.data?.[0]?.attributes?.design === "new";

  return {
    props: {
      apiResData,
      slug,
      isNew,
    },
  };
};

const UseCaseDetail: NextPage<UseCaseDetailProps> = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <UseCasePage slug={slug} data={apiResData} />
    </div>
  );
};

export default UseCaseDetail;
